import React from "react"

import {
  SmartMatchingData,
  SmartMatchingDataPerson,
} from "~/SmartMatching/SmartMatchingContext"
import CollapsibleSection from "./CollapsibleSection"
import { summarizeMatches } from "./helpers/summarizeMatches"

type Props = {
  smartMatchingData: SmartMatchingDataPerson
  embeddingFields: SmartMatchingData["embeddingFields"]
}

const CustomSelectOptionsSection = ({
  smartMatchingData,
  embeddingFields,
}: Props) => {
  if (smartMatchingData.matchedCustomSelectOptions.length === 0) {
    return null
  }

  // Group custom select options by typeId
  const groupedByTypeId = smartMatchingData.matchedCustomSelectOptions.reduce(
    (acc, option) => {
      const typeId = option.source.typeId
      if (!acc[typeId]) {
        acc[typeId] = []
      }
      acc[typeId] = [...acc[typeId], option]
      return acc
    },
    {} as Record<number, typeof smartMatchingData.matchedCustomSelectOptions>,
  )

  // Create sections for each custom field type
  return (
    <>
      {Object.entries(groupedByTypeId)
        .map(([typeIdStr, options]) => {
          const typeId = Number(typeIdStr)

          // Find the corresponding custom field type in embeddingFields
          const embeddingFieldForType = embeddingFields.find(
            (field) => field.customSelectTypeId === typeId,
          )

          if (!embeddingFieldForType) {
            return null
          }

          // Get the specific field score for this custom field type
          const scoreForType = smartMatchingData.scores.fieldScores.find(
            (score) => score.embeddingFieldId === embeddingFieldForType.id,
          )?.score

          return (
            <CollapsibleSection
              key={`CUSTOM_FIELD-${typeId}`}
              title={`Custom Field ${typeId}`}
              summary={summarizeMatches(options)}
              score={scoreForType}
            >
              <div>Custom field details will go here...</div>
            </CollapsibleSection>
          )
        })
        .filter(Boolean)}
    </>
  )
}

export default CustomSelectOptionsSection
